module.exports = __webpack_public_path__ + "static/media/ImperialTobacco.23718b43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ImperialTobacco.svg
// module id = 1766
// module chunks = 0